import React, { useState } from 'react';
import {
  Dialog as BPDialog,
  DialogProps as IDialogProps
} from '@blueprintjs/core';
import PortalContainerRef from '../../atoms/portal-container';
import cc from 'classcat';

import './index.scss';

interface DialogProps extends IDialogProps {
  maxWidth?: string;
  className?: string;
  forceScrollY?: boolean;
}

const Dialog: React.FC<DialogProps> = ({
  children,
  className,
  forceScrollY,
  maxWidth,
  ...props
}) => {
  const style = {
    maxWidth: maxWidth ? maxWidth : '900px'
  };
  const classes = cc(['bg-white w-screen', className ? className : undefined]);
  const portalClasses = cc([
    {
      'force-scrollbar-y': forceScrollY
    }
  ]);
  return (
    <BPDialog
      className={classes}
      portalClassName={portalClasses}
      {...props}
      style={Object.assign({}, props.style, style)}
      portalContainer={PortalContainerRef.current}
    >
      {children}
    </BPDialog>
  );
};

export default Dialog;

export const DebouncedDialog: React.FC<DialogProps> = ({
  children,
  ...props
}) => {
  const [isInTransition, setIsInTransition] = useState(false);
  return (
    <Dialog
      {...props}
      onOpening={() => setIsInTransition(true)}
      onOpened={() => setIsInTransition(false)}
      canOutsideClickClose={!isInTransition}
      canEscapeKeyClose={!isInTransition}
    >
      {children}
    </Dialog>
  );
};
